import styled from 'styled-components';
import { font, color, query, space } from '@design/templateFns';

export const GridContainer = styled.div<{ $reverse?: boolean }>`
  display: flex;
  justify-content: space-between;
  gap: 70px;
  flex-direction: ${({ $reverse }) => ($reverse ? 'column-reverse' : 'column')};

  @media screen and (${query.atLeast('tablet')}) {
    gap: 30px;
    flex-direction: ${({ $reverse }) => ($reverse ? 'row-reverse' : 'row')};
    max-width: 1400px;
    margin: auto;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  grid-row: 2;
  max-width: 600px;
  @media screen and (${query.atLeast('tablet')}) {
    margin-top: 0;
    grid-row: 1;
    justify-self: inherit;
  }
`;

export const Header = styled.h2`
  ${font('headline-xxs')};
  margin: 0 0 28px;
  max-width: 743px;
  padding: 0;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('headline-sm')};
  }
`;

export const Eyebrow = styled.h3`
  text-transform: uppercase;
  color: ${color('cta')};
  ${font('eyebrow-sm')};
  padding-bottom: 15px;
  margin-top: 0;

  @media screen and (${query.atLeast('desktop')}) {
    font-size: 14px;
    ${font('eyebrow-md')};
  }
`;

export const Text = styled.div`
  ${font('body-sm-light')};

  margin-bottom: 52px;
  p {
    margin: 0;
  }

  @media screen and (${query.atLeast('desktop')}) {
    ${font('body-md-light')};
  }
`;

export const ImageContainer = styled.div`
  flex: 1 0 45%;

  @media screen and (${query.atLeast('tablet')}) {
    width: 300px;
    height: 300px;
  }
  @media screen and (${query.atLeast('desktop')}) {
    width: 500px;
    height: 500px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;

  gap: 20px;
  flex-direction: column;
  @media screen and (${query.atLeast('tablet')}) {
    flex-direction: row;
  }
`;
